import React from 'react';
import { useTranslations } from '@lang';

import Alert from '@common/components/Alert/Alert';

export const NoMoreRoomsAvailable = () => {
  const { t } = useTranslations();

  return (
    <Alert
      title={t('roomListing.noMoreAvailableTitle')}
      content={t('roomListing.noMoreAvailableDescription')}
    />
  );
};
